import { STATUS_META } from "../ticketMeta";
import styles from "./statusPill.module.css";

// A ticket's status as a small colored pill.
const StatusPill = ({ status }) => {
  const meta = STATUS_META[status] || STATUS_META.open;
  return (
    <span className={`${styles.pill} ${styles[meta.tone]}`}>
      <span className={styles.dot} aria-hidden="true" />
      {meta.label}
    </span>
  );
};

export default StatusPill;
